import React, { useState } from "react"
import PropTypes from "prop-types"
import Header from "./Header/header"
import "./layout.scss"
import HeaderTop from "./HeaderTop/header-top"
import Footer from "./Footer/footer"
import { NotificationContext } from "../notification-context"
import { ThemeProvider } from "styled-components"
import StyledContainer from "./layout-styled"
import { useBuildData } from "../../hooks/use-build-data"
import { library } from "@fortawesome/fontawesome-svg-core"
import { fab } from "@fortawesome/free-brands-svg-icons"
import { fas } from "@fortawesome/free-solid-svg-icons"
import { far } from "@fortawesome/free-regular-svg-icons"

const Layout = ({
  children,
  isIndex,
  isDetail,
  message,
  isGdd,
  inputHidden,
}) => {
  library.add(fab, fas, far)
  const buildColors = useBuildData().theme_settings.palette
  const fontsHeading = useBuildData().theme_settings.typography_heading
  const fontsText = useBuildData().theme_settings.typography_text
  const theme = buildColors
  theme.fontsHeading = fontsHeading
  theme.fontsText = fontsText
  const [isOpen, setIsOpen] = useState(false)

  return (
    <ThemeProvider theme={theme}>
      <NotificationContext.Provider value={{ isOpen, setIsOpen }}>
        <StyledContainer>
          {!isGdd && <Header />}
          <HeaderTop
            isGdd={isGdd}
            isDetail={isDetail}
            isIndex={isIndex}
            message={message}
            inputHidden={inputHidden}
          >
            {children}
          </HeaderTop>
          <Footer></Footer>
        </StyledContainer>
      </NotificationContext.Provider>
    </ThemeProvider>
  )
}

//-----------------------Styled Component---------------------------//

//-----------------------Styled Component---------------------------//

//-----------------------Prop-Types---------------------------//

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  isIndex: PropTypes.bool,
  isDetail: PropTypes.bool,
  message: PropTypes.string,
  isGdd: PropTypes.bool,
  inputHidden: PropTypes.bool,
}

//-----------------------Prop-Types---------------------------//

export default Layout
